import { combineReducers } from "redux";
import * as ActionTypes from "./content.actionTypes";
import * as AuthActionTypes from "../auth/auth.actionTypes";
import keys from "lodash/keys";
import merge from "lodash/merge";
import omit from "lodash/omit";
import union from "lodash/union";

const allIds = (state = [], action) => {
  // Clear state when admin logins as another user
  if(action.type === AuthActionTypes.ADMIN_LOGIN_REQUEST){
    return [];
  }

  switch (action.type) {
    case ActionTypes.CREATE_CONTENT_SUCCESS:
      return [...state, action.response.result];
    case ActionTypes.DELETE_CONTENT_SUCCESS:
    case ActionTypes.DELETE_CONTENT_FAILURE:
      //TODO remove entry
      const deletedIndex = state.indexOf(action.payload.id);
      if (deletedIndex === -1) {
        return state;
      }
      return [
        ...state.slice(0, deletedIndex),
        ...state.slice(deletedIndex + 1)
      ];
    case ActionTypes.READ_CONTENT_SUCCESS:
      const newEntryIndex = state.indexOf(action.response.result);
      if (newEntryIndex > -1) {
        return state;
      }
      return [...state, action.response.result];
    case ActionTypes.READ_CONTENTS_SUCCESS:
    case ActionTypes.FILTER_CONTENTS_SUCCESS:
      return union(state, action.response.result.content);

    default:
      return state;
  }
};

const filterPage = (state = 0, action) => {
  if (action.type === ActionTypes.FILTER_CONTENTS_SUCCESS) {
    return action.response.result.page || state;
  }
  return state;
};

const filterShowMore = (state = false, action) => {
  if (action.type === ActionTypes.FILTER_CONTENTS_SUCCESS) {
    return action.response.result.showMore;
  }
  return state;
};

const filteredIds = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.RESET_FILTER:
      return [];
    case ActionTypes.FILTER_CONTENTS_SUCCESS:
      return action.response.result.content;
    case ActionTypes.FILTER_CONTENTS_REQUEST:
    case ActionTypes.FILTER_CONTENTS_FAILURE:
      return state;

    default:
      return state;
  }
};

const showMore = (state = false, action) => {
  if (action.type === ActionTypes.READ_CONTENTS_SUCCESS) {
    return action.response.result.showMore;
  }
  return state;
};

const tags = (state = [], action) => {
  if (action.type === ActionTypes.READ_TAGS_SUCCESS) {
    return action.response.result.tags;
  }
  return state;
};

const page = (state = 0, action) => {
  if (action.type === ActionTypes.READ_CONTENTS_SUCCESS) {
    return action.response.result.page || state;
  }
  return state;
};

const byId = (state = {}, action) => {
  // Clear state when admin logins as another user
  if(action.type === AuthActionTypes.ADMIN_LOGIN_REQUEST){
    return {};
  }

  if (
    action.response &&
    action.response.entities &&
    action.response.entities.content
  ) {
    if (action.response.method && action.response.method === "DELETE") {
      console.log(
        "//DELETE ENTITIES FROM STATE",
        state,
        action.response.entities
      );
      return omit(state, keys(action.response.entities.content));
    }
    return merge({}, state, action.response.entities.content);
  }
  return state;
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case ActionTypes.READ_CONTENTS_REQUEST:
    case ActionTypes.FILTER_CONTENTS_REQUEST:
      return true;
    case ActionTypes.READ_CONTENTS_SUCCESS:
    case ActionTypes.READ_CONTENTS_FAILURE:
    case ActionTypes.FILTER_CONTENTS_SUCCESS:
    case ActionTypes.FILTER_CONTENTS_FAILURE:
      return false;
    default:
      return state;
  }
};

const isFetchingTags = (state = false, action) => {
  switch (action.type) {
    case ActionTypes.READ_TAGS_REQUEST:
      return true;
    case ActionTypes.READ_TAGS_SUCCESS:
    case ActionTypes.READ_TAGS_FAILURE:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  allIds,
  filter: combineReducers({
    filteredIds,
    showMore: filterShowMore,
    page: filterPage
  }),
  //filteredIds,
  byId,
  isFetching,
  isFetchingTags,
  showMore,
  page,
  tags
  //errorMessage,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/content/content.reducer.js